import './newsfeed.scss'
import { useState } from 'react'
import { TextField, Grid, Button } from '@mui/material';
import Image from './../../../assets/home/newsfeed/profile.png'
import applaud from './../../../assets/home/newsfeed/applaud.png'
import broadcast from './../../../assets/home/newsfeed/broadcast.png'
import vote from './../../../assets/home/newsfeed/vote.png'
import PostModel from './post-model';


const AddPost = (props: any) => {
    const {setAddData, setConvertedContent} = props;
    const [toggle, setToggle] = useState<any>()
    const [counter, setCounter] = useState<any>()
    const [postData, setPostData] = useState()

    const postDataHandler = (event: any) => {
        setPostData(event.target.value);
    }

 console.log(postData);
    return (

        <div className='br-16 post' >
            <Grid className='d-flex'>
                <img src={Image} alt="" style={{ paddingRight: "20px", height: "48px" }} />
                <TextField
                onClick={() => { setCounter(1); setToggle(true) }}
                    InputLabelProps={{
                        style: { color: '#fff', cursor: "none", }
                     }}
                     sx={{
                        marginBottom: "20px",
                        '& label.Mui-focused': {
                            color: '#A7A5B3',
                            cursor: "none",
                        },
                        '& .MuiInput-underline:after': {
                            borderBottomColor: '#A7A5B3',
                            cursor: "none",
                        },
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: '#A7A5B3',
                                cursor: "none",
                            },
                            '&:hover fieldset': {
                                borderColor: '#A7A5B3',
                                cursor: "none",
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#A7A5B3',
                                cursor: "none",
                            },
                        },
                    }}
                    // sx={{
                    //     input: {fontFamily: "poppins"},
                    //     "& .MuiOutlinedInput-root.Mui-focused": {
                    //         "& > fieldset": {
                    //             borderColor: "#A7A5B3"
                    //         },
                    //     }
                    // }}
                    fullWidth id="outlined-basic" placeholder='Have something to say?' variant="outlined" />
            </Grid>
            <Grid className='d-flex post-options responsive-post-options' sx={{ justifyContent: "space-around", padding:{xs: "10px 0px" ,sm: "10px 0px", md: "10px" }, marginTop: "20px" }} >
                <Grid className='d-flex justify-center ' xs={4}>
                    <img src={applaud} alt="" />
                    <Button onClick={() => { setCounter(1); setToggle(true) }}>Broadcast</Button>
                </Grid>
                <Grid className='d-flex justify-center ' xs={4}>
                    <img src={broadcast} alt="" />
                    <Button onClick={() => { setCounter(2); setToggle(true) }}>Applaud</Button>
                </Grid>
                <Grid className='d-flex justify-center' xs={4}>
                    <img src={vote} alt="" />
                    <Button onClick={() => { setCounter(3); setToggle(true) }}>Vote</Button>
                </Grid>
            </Grid>
            {toggle && <PostModel setAddData={setAddData} setConvertedContent={setConvertedContent} counter={counter} setCounter={setCounter} toggle={toggle} setToggle={setToggle} />}
        </div>
    )
}

export default AddPost